module.exports = __webpack_public_path__ + "img/colab-consejo-estado.bf5c3c9a.jpg";